module.exports = __webpack_public_path__ + "static/media/Arthur Weasley 1.95cb21b1.jpg";